/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.18",
    versionName: "0.2.0-nightly.2026.3.18",
    versionChannel: "nightly",
    buildDate: "2026-03-18T00:12:14.734Z",
    commitHash: "9a78479512f2026c0d4bef303ea9c886c005f1a9",
};
